import { render, staticRenderFns } from "./share-form.vue?vue&type=template&id=c36b7558&scoped=true"
import script from "./share-form.vue?vue&type=script&lang=js"
export * from "./share-form.vue?vue&type=script&lang=js"
import style0 from "./share-form.vue?vue&type=style&index=0&id=c36b7558&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36b7558",
  null
  
)

export default component.exports